import { render, staticRenderFns } from "./33bzhjyxbg.vue?vue&type=template&id=84efe69a&"
import script from "./33bzhjyxbg.vue?vue&type=script&lang=js&"
export * from "./33bzhjyxbg.vue?vue&type=script&lang=js&"
import style0 from "./33bzhjyxbg.vue?vue&type=style&index=0&id=84efe69a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports